import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({name: 'formatDate'})
export class FormatDatePipe implements PipeTransform {
  transform(value: any, format: string, timezone?: string): any {
    const date = moment(value);
    return date.tz('Europe/Berlin').format(format);
  }
}
